export default "__VITE_ASSET__GZrR4_3K__"